import React from 'react';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

import makeStyles from '@mui/styles/makeStyles';
import { newDate } from '../../../utils/date-utils';
import { version } from '../../../../package.json';

function Copyright() {
  const appVersion = process.env.REACT_APP_VERSION || version;

  return (
    <Typography
      variant="body2"
      color="textSecondary"
      align="center"
      aria-label="footer"
    >
      v{appVersion}
      {' - '}
      {'Copyright © '}
      <Link color="inherit" href="https://eatzy.com/">
        Eatzy
      </Link>{' '}
      {newDate().getFullYear()}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  footer: {
    padding: theme.spacing(3, 2),
    marginTop: 'auto',
  },
}));

export function Footer() {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <Container maxWidth="sm">
        <Copyright />
      </Container>
    </footer>
  );
}
